import { useAppDispatch, useAppSelector } from 'src/app/store/hooks';
import { TagsFilter } from 'src/common/tags/TagsFilter';

import { teamSlice } from '../team.slice';

export function DriverTagColumnFilter({
  open,
  onClose,
}: {
  open: boolean;
  onClose: () => void;
}) {
  const dispatch = useAppDispatch();
  const selected = useAppSelector((state) => state.team.driverTags);

  return (
    <TagsFilter
      open={open}
      selected={selected}
      triggerElement={<div />}
      onApply={(tags) => {
        dispatch(teamSlice.actions.onDriverTagApply(tags));
      }}
      onClose={onClose}
    />
  );
}
